import { Box } from '@/components/primitives'
import { FC, ReactNode, useContext, useEffect } from 'react'
import Navbar from './navbar'
import { CommunityLink } from './home/Footer'
import { ToastContext } from '@/context/ToastContextProvider'
import { getRandom, GetInvestments, Getwithdraw } from './Sanity/SanityContext'
type Props = {
  children: ReactNode
}



const Layout: FC<Props> = ({ children }) => {
  const { addToast } = useContext(ToastContext)

  useEffect(() => {
    setInterval(() => {
      (async () => { 
        const result= (await Getwithdraw()).result;  
        addToast?.({
          status: 'success',
          title: `New Withdraw`,
          description: `${result?.withdraw?.name} from ${result?.withdraw?.country} Withdraw ${result?.withdraw?.withdraw} USD. \n Date:${new Date()}`,
      })
      })()
    }, randomIntFromInterval(30000,600000));
  },[])

  useEffect(() => {  
    setInterval(() => {
      (async () => {
        const result= (await GetInvestments()).result;   
        addToast?.({
          status: 'success',
          title: `New Investment`,
          description: `${result?.invester?.name} from ${result?.invester?.country} invested ${result?.invester?.investment} USD. \n Date:${new Date()}`,
      })
      })()
    }, randomIntFromInterval(30000,300000));
  },[])

  function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  return (
    <>
      <Box
        css={{
          background: '$neutralBg',
          height: '100%',
          minHeight: '100vh',
          pt: 80,
        }}
      >
        <Box css={{ maxWidth: 4500, mx: 'auto' }}>
          <Navbar />
          <main>{children}</main>
        </Box>
        <CommunityLink />
      </Box>
    </>
  )
}

export default Layout
